import React from "react";
import { Grid } from "@material-ui/core";
import { useCurrentTradingDataFilter } from "../../../data/clearing/tradingData/hooks/useTradingDataFilter";
import { DateInput } from "../../components/common/DateInput";
import { isValidDate } from "../../../core/util/functions";
import { LocalizationContext } from "../../../core/localization/Localization";

export const TradingDateInput: React.FunctionComponent = () => {
	const [filter, ,setReportDate] = useCurrentTradingDataFilter();
	const { getString } = React.useContext(LocalizationContext);

	return (
		<Grid container alignItems="center" spacing={2}>
			<Grid item>
				<DateInput
					clearable={false}
					label={getString("tradingDataReportDate")}
					value={filter?.reportDate || null}
					onChange={date => {
						if (isValidDate(date)) {
							setReportDate(date.toISOString());
						}
					}}
					disableFuture
				/>
			</Grid>
		</Grid>
	);
};
